$(document).ready(function() {
    bulmaAccordion.attach();
});